import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #274060;
`

export const Field = styled.span`
  font-size: 12px;
  font-weight: 700;
  text-transform: lowercase;
`

export const Value = styled.span`
  font-size: 14px;
`
